import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function LandSubItemContainer({
  classificationId,
  getSingleLandClass,
  getSubClassificationsItemsList,
  subClassificationItemsList,
  removeLandSubItem,
  classificationInfo,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(classificationId)) return;
    getSingleLandClass(classificationId);
    getSubClassificationsItemsList(classificationId)
  }, []);
  useEffect(() => {
    if (_.isEmpty(classificationId)) return;
    getSingleLandClass(classificationId);
  }, [classificationId]);

  const addSubItem = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal classificationId={classificationId} />,
      title: 'Add Land Sub Classification Item',
      modalSize: 'modal-md',
    });
  };

  const updateSubItem = (data, id) => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={data}
          id={id}
          classificationId={data.rptax_land_classification_id}
        />
      ),
      title: 'Update Land Sub Classification Item',
      modalSize: 'modal-md',
    });
  };

  const removeSubItem = (id, subClassId) => e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this Land Sub Classification Item?',
      () => {
        removeLandSubItem(id, subClassId, () => {
          getSingleLandClass(id)
          getSubClassificationsItemsList(id)
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className="row d-flex justify-content-between align-items-center">
          <div className="col-10">
            <h3 className="">Information</h3>
          </div>
        </div>
        <hr />
        <div className="mt-1">
          <div className="row d-flex justify-content-center">
            <div className="col-12">
              <div className="form-wrapper mb-3">
                <div className="full-group ">
                  <div className="form-row">
                    <div className="form-input-group col-12 ">
                      <label className="full-label mb-0">Classification Name:</label>
                      <span className="full-input">
                        {_.get(classificationInfo, 'attributes.name') ||
                          '--'}
                      </span>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-input-group col-12 ">
                      <label className="full-label mb-0">Description:</label>
                      <span className="full-input">
                        {_.get(classificationInfo, 'attributes.description') ||
                          '--'}
                      </span>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-input-group col-12 ">
                      <label className="full-label mb-0">
                        Is Active:
                      </label>
                      <span className="full-input">
                        {_.get(classificationInfo, 'attributes.is_active')
                          ? 'YES'
                          : 'NO'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex justify-content-center w-100 border-top">
              <div className="font-weight-bold col-12 mt-2 text-right">
                <button
                  type="button"
                  onClick={addSubItem}
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4"
                >
                  Add&nbsp;
                  <i className="fas fa-plus" />
                </button>
              </div>
            </div>
            <div className="row d-flex justify-content-center w-100">
              <div className="font-weight-bold col-12 mt-2 text-center">
                Land Sub Classification Items
              </div>
              <div className="col-12">
                <table className="table table-striped table-borderless">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {subClassificationItemsList && subClassificationItemsList.length ? (
                      subClassificationItemsList.map((subItem) => (
                        <tr key={`sub-classification-item-${subItem.id}`}>
                          <td>{subItem.attributes.name}</td>
                          <td>{subItem.attributes.description}</td>
                          <td>
                            <button
                              type="button"
                              className="btn-blank"
                              onClick={updateSubItem(_.get(subItem, 'attributes'), _.get(subItem, 'id'))}
                            >
                              <i className="far fa-edit icon-edit" />
                            </button>
                            <button
                              type="button"
                              className="btn-blank"
                              onClick={removeSubItem(_.get(subItem, 'attributes.rptax_land_classification_id'), _.get(subItem, 'id'))}
                            >
                              <i className="far fa-trash-alt icon-delete" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td>No Data</td>
                        <td />
                        <td />
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
LandSubItemContainer.defaultProps = {};

LandSubItemContainer.propTypes = {
  getSingleLandClass: PropTypes.instanceOf(Function).isRequired,
  removeLandSubItem: PropTypes.instanceOf(Function).isRequired,
  getSubClassificationsItemsList: PropTypes.instanceOf(Function).isRequired,
  subClassificationItemsList: PropTypes.instanceOf(Array).isRequired,
  classificationInfo: PropTypes.instanceOf(Object).isRequired,
  classificationId: PropTypes.string.isRequired,
};

const mapStateToProps = ({api}) => ({
  subClassificationItemsList: _.get(api, `${c.GET_LAND_SUB_CLASSIFICATIONS_ITEMS}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandSubItemContainer);
